module.exports = __webpack_public_path__ + "static/media/fontello.3356d0ae.ttf";